import { SharedAvallinieService } from '@/shared/api/services/avallinie.ts';
import type { AvallinieFilterResponse } from '@/connection/filter-helper/filter-helper-avallinien.ts';
import type { FilterOptionen } from '@/components/datatable/types/FilterObject.ts';
import type { Avallinie } from '@/shared/Avallinie/types.ts';
import { centsToEuro, euroToCents } from '@/auftraggeber/utils/useAvallinie/useAvallinie';
import type { Kautionsvertrag } from '@/types/Vertrag.ts';

export class AvallinieService extends SharedAvallinieService {
  async getFilterOptionsAvallinie(): Promise<FilterOptionen> {
    return this.httpClient.post(`${this.avallinieServiceBaseUrl}/avallinie/filteroptionen`);
  }

  async findAvallinien(
    page: number,
    size: number,
    sort: string,
    direction: string,
    buergeIds?: string[],
  ): Promise<AvallinieFilterResponse> {
    return this.httpClient.get(`${this.avallinieServiceBaseUrl}/avallinie`, {
      params: { page, size, sort: `${sort},${direction}`, buergeIds: buergeIds.join(',') },
    });
  }

  async erstelleAvallinie(avallinie: Avallinie): Promise<Avallinie> {
    return this.httpClient.post<Avallinie>(`${this.avallinieServiceBaseUrl}/avallinie`, {
      data: euroToCents(avallinie),
    });
  }

  async aktualisiereAvallinie(avallinieId: number, avallinie: Avallinie): Promise<Avallinie> {
    return this.httpClient.put<Avallinie>(
      `${this.avallinieServiceBaseUrl}/avallinie/${avallinieId}`,
      {
        data: euroToCents(avallinie),
      },
    );
  }

  async findAvallinie(avallinieId: number): Promise<Avallinie> {
    return this.httpClient
      .get<Avallinie>(`${this.avallinieServiceBaseUrl}/avallinie/${avallinieId}`)
      .then(centsToEuro);
  }

  canCreateNew(): Promise<boolean> {
    return this.httpClient.get<boolean>(`${this.avallinieServiceBaseUrl}/avallinie/canCreateNew`);
  }

  async delete(avallinieId: number): Promise<Kautionsvertrag> {
    return this.httpClient.delete(`${this.avallinieServiceBaseUrl}/avallinie/${avallinieId}`);
  }
}
